import { z } from 'zod';

const matchSchema = z.object({
  symbol: z.string(),
  name: z.string(),
  type: z.string().optional(),
  region: z.string().optional(),
  currency: z.string().optional(),
  matchScore: z.number().optional()
});

export type SymbolMatch = z.infer<typeof matchSchema>;

import { apiClient } from '@/services';
import { buildQueryString } from '@macroinsight/shared-api-client';

export async function searchAlphaSymbols(query: string): Promise<SymbolMatch[]> {
  const q = query.trim();
  if (!q) return [];

  const queryString = buildQueryString({ q });
  const path = `/api/assets/symbol-search${queryString ? `?${queryString}` : ''}`;

  const response = await apiClient.get<SymbolMatch[]>(path);

  if (response.success && response.data) {
    const validated = z.array(matchSchema).safeParse(response.data);
    if (validated.success) {
      return validated.data;
    }
    return [];
  }

  return [];
}
